import http from './http.js'
import './config.js'

const requireApi = require.context('.././modules', true, /\.js$/)
const request = requireApi.keys().reduce((result, path) => {
	const moduleName = path.replace(/^\.\/([\w-]+)\/([\w-]+)\.js$/, '$1==$2').split('==')
	const moduleContent = requireApi(path).default || []
	const moduleApi = moduleContent.reduce((pre, cur) => {
		const docs = { [cur.name + '_docs']: cur.docs }
		return {
			...pre,
			...docs,
			[cur.name]: function (params = {}, id) {
				const method = http[cur.method]
				const data = {
					...cur.params,
					...params
				}
				return method(cur.url, cur.method === 'upload' ? params : data, id)
			}
		}
	}, {})
	return {
		...result,
		[moduleName[1]]: moduleApi
	}
}, {})

export default request
